import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-missing-shares-info",
  // imports: [],
  templateUrl: "./missing-shares-info.component.html",
  styleUrl: "./missing-shares-info.component.css",
  standalone: false,
})
export class MissingSharesInfoComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
